import React from 'react';
import { Button } from 'antd';
import theme from '@/assets/theme';
import extensivLogo from '@/assets/images/extensiv-logo.png';

const UNIPHAR_THEME_TYPE = 19;
const EXTENSIV_URL = 'https://secure-wms.com';

/**
 * Uniphar-only shortcut to Extensiv (3PL Central / secure-wms).
 * Hidden on all other whitelabel themes.
 */
const ExtensivPortalButton: React.FC = () => {
  if (theme.themeType !== UNIPHAR_THEME_TYPE) return null;

  return (
    <Button
      href={EXTENSIV_URL}
      target='_blank'
      rel='noopener noreferrer'
      data-testid='extensiv-portal-button'
      style={{
        width: '100%',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        border: '1px solid #d9d9d9',
        borderRadius: '8px',
        backgroundColor: 'var(--surface-container)',
        color: '#3c4043',
        fontWeight: 500,
        fontSize: '14px',
        marginTop: '20px',
      }}
      block
    >
      <img
        src={extensivLogo}
        alt=''
        width={20}
        height={20}
        style={{ display: 'block', objectFit: 'contain' }}
      />
      Go to Extensiv
    </Button>
  );
};

export default ExtensivPortalButton;
